export default __webpack_public_path__ + "static/media/gps.b7059703.svg";